import { useEffect, useState, useCallback } from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

import SalesImpression from 'scripts/utils/dataLayer/Sales/SalesImpression'

import { GenericCarousel } from 'reactGarden/GenericCarousel'

import { useDataLayerPush } from 'reactUtils/hooks/use-data-layer-push'

import { Widget } from '../components/Widget'
import Banner from '../components/Banner'
import bannerPropTypes from '../prop-types/banner'

const widgetStyles = ({ theme }) =>
  css`
    .swiper-pagination-bullet-active {
      background: ${theme.colors.p500};
    }
  `

const StyledWidget = styled.div(widgetStyles)

const widgetType = 'carousel_full_banner'

const FullBannerCarousel = ({
  type,
  banners,
  noTopSpacing = false,
  noBottomSpacing = false
}) => {
  const [sideColors, setSideColors] = useState({ left: '', right: '' })
  const dataLayerOptions = {}

  if (banners.length) {
    dataLayerOptions.callback = () =>
      new SalesImpression(banners, type).sendImpressionToDataLayer()
  }

  useDataLayerPush(dataLayerOptions)

  const changeSlide = useCallback(
    function () {
      const currentBanner = banners[this.activeIndex - 1] || banners[0]
      setSideColors(currentBanner.pictures[widgetType].sideBackgroundColors)
    },
    [banners]
  )

  useEffect(() => {
    if (banners.length && 'pictures' in banners[0]) {
      setSideColors(banners[0].pictures[widgetType].sideBackgroundColors)
    }
  }, [banners])

  if (!banners.length) {
    return null
  }

  return (
    <StyledWidget>
      <Widget
        noTopSpacing={noTopSpacing}
        noBottomSpacing={noBottomSpacing}
        sideBackgroundColors={sideColors}
        full={true}
      >
        <GenericCarousel
          autoplay={{ delay: 5000 }}
          loop={banners.length > 1}
          onSlideChange={changeSlide}
          pagination={{ clickable: true }}
          slidesPerView={1}
          hasOffset={false}
          freeMode={false}
        >
          {banners.map((banner, index) => (
            <div key={`banner-${banner.id}`}>
              <Banner
                position={index + 1}
                parentWidgetType={widgetType}
                {...banner}
              />
            </div>
          ))}
        </GenericCarousel>
      </Widget>
    </StyledWidget>
  )
}

FullBannerCarousel.propTypes = {
  type: PropTypes.string.isRequired,
  banners: PropTypes.arrayOf(PropTypes.shape(bannerPropTypes)).isRequired,
  noTopSpacing: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  noBottomSpacing: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}

export default FullBannerCarousel
